import reduceReducer from '@helpers/reduceReducers';

import {
  reducer,
  opticalTrackingReducer,
  transcriptionReducer,
  backgroundBlurReducer,
  undoReducer,
  viewReducer,
  workerReducer,
} from './reducers';

export const mediaDetailsReducer = reduceReducer(
  reducer,
  opticalTrackingReducer,
  transcriptionReducer,
  backgroundBlurReducer,
  undoReducer,
  viewReducer,
  workerReducer
);

export * from './actions';
export * from './leaveSignals';
export * from './redactionStatuses';
export * from './selectors';
export * from './store';
